import { createContext, useState } from 'react';

export interface ErrorContextType {
  error: { statusCode: number } | null;
  setError: (error: { statusCode: number } | null) => void;
}

export const ErrorContext = createContext<ErrorContextType | null>(null);

export const ErrorProvider = ({ children }: { children: React.ReactNode }) => {
  const [error, setError] = useState<{ statusCode: number } | null>(null);

  return (
    <ErrorContext.Provider value={{ error, setError }}>
      {children}
    </ErrorContext.Provider>
  );
};
